import { defineMessages } from 'react-intl';

export default defineMessages({
    incidentReportedBY: {
        id: 'tdic.fnol.bop.views.incident.Reported By',
        defaultMessage: 'Reported By'
    },
    reportedThrough: {
        id: 'tdic.fnol.bop.views.incident.Reported Through',
        defaultMessage: 'Reported Through'
    },
    personName: {
        id: 'tdic.fnol.bop.views.incident.Name',
        defaultMessage: 'Name'
    },
    relationToInsured: {
        id: 'tdic.fnol.bop.views.incident.Relation to Insured',
        defaultMessage: 'Relation to Insured'
    },
    dateOfNotice: {
        id: 'tdic.fnol.bop.views.incident.Date of Notice (Date you became aware of incident)',
        defaultMessage: 'Date of Notice (Date you became aware of incident)'
    },
    description: {
        id: 'tdic.fnol.bop.views.what.Describe what happened',
        defaultMessage: 'Describe what happened'
    },
    pleaseSelect: {
        id: 'tdic.fnol.bop.views.Please Select',
        defaultMessage: 'Please Select'
    },
    selectLossCause: {
        id: 'tdic.fnol.bop.views.what.Select Loss Cause',
        defaultMessage: 'Select Loss Cause'
    },
    lossCause: {
        id: 'tdic.fnol.bop.views.what.Loss Cause',
        defaultMessage: 'Loss Cause'
    },
    describeDamage: {
        id: 'tdic.fnol.bop.views.what.Describe Damage',
        defaultMessage: 'Describe Damage'
    },
    damagedList: {
        id: 'tdic.fnol.bop.views.what.list of Damages',
        defaultMessage: 'List what was damaged or lost during the incident, such as structural damage or office equipment'
    }
});
